import { render, staticRenderFns } from "./AnnotationColorationHelper.vue?vue&type=template&id=393c11f7&scoped=true"
import script from "./AnnotationColorationHelper.vue?vue&type=script&lang=ts"
export * from "./AnnotationColorationHelper.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationColorationHelper.vue?vue&type=style&index=0&id=393c11f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c11f7",
  null
  
)

export default component.exports